import { StyleProp, ViewStyle } from 'react-native';

interface LoadedEvent {
  id: number;
}

interface ErrorEvent {
  name: string;
  message: string;
  method: string;
}

interface TimeEvent {
  duration: number;
  percent: number;
  seconds: number;
}

export type VimeoPayload =
  | {
      name: 'loaded';
      data: LoadedEvent;
    }
  | {
      name: 'error';
      data: ErrorEvent;
    }
  | {
      name: 'ended' | 'pause' | 'play' | 'timeupdate';
      data: TimeEvent;
    };

interface VimeoPlayerActionProps {
  onPlay?: (event: TimeEvent) => void;
  onPause?: (event: TimeEvent) => void;
  onEnded?: (event: TimeEvent) => void;
  onError?: (event: ErrorEvent) => void;
  onLoaded?: (event: LoadedEvent) => void;
  onTimeUpdate?: (event: TimeEvent) => void;
}

export interface VimeoPlayerProps extends VimeoPlayerActionProps {
  autoplay?: boolean;
  autopause?: boolean;
  loop?: boolean;
  controls?: boolean;
  src: string;
  ratio: number;
  maxHeight?: number;
  containerStyle?: StyleProp<ViewStyle>;
}

export const RATIO_9_16 = 0.5625;
export const RATIO_16_9 = 1.77777777;

export interface VimeoVideoProps extends VimeoPlayerActionProps {
  src: string;
  width: number;
  height: number;
}
